<template>
  <div class="moderation-case-box-container" @click="emitCaseSelected">
    <div class="moderation-case-data-row">
      <div class="moderation-case-text">
        <span class="moderation-case-label">Reason</span>
        <p class="moderation-case-value">{{ reason !== '' ? reason : "No reason indicated." }}</p>
      </div>
      <div class="moderation-case-text">
        <span class="moderation-case-label">Reported at</span>
        <p class="moderation-case-value"> {{ date }}</p>
      </div>
    </div>
    <div class="moderation-case-data-row">
      <div class="moderation-case-text">
        <span class="moderation-case-label">Image ID</span>
        <p class="moderation-case-value">{{ imageId }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import {formatDateUS} from "@/util/dateUtil";

const date = ref(null);

const props = defineProps({
  createdAt: String,
  imageId: String,
  reason: String
});

const emit = defineEmits(['selected'])

onMounted(() => {
  date.value = formatDateUS(Date.parse(props.createdAt))
})

function emitCaseSelected() {
  emit('selected')
}

</script>

<style scoped>

.moderation-case-box-container {
  width: 100%;
  border: 1px solid lightgray;
  box-sizing: border-box;
  padding: 0.7rem;
  border-radius: 10px;
  box-shadow: 0px 1px 5px rgb(250 250 250 / 0.66);
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 0.5rem;
}

.moderation-case-box-container:hover {
  cursor: pointer;
  background-color: rgb(244 244 244 / 0.75);
}

.moderation-case-label {
  font-size: 0.8rem;
  font-weight: lighter;
}

.moderation-case-value {
  margin: 0;
}

.moderation-case-data-row {
  display: flex;
  gap: 2rem;
}

</style>